import type {
  ImportEventsPayload,
  SequenceActivatedPayload,
  SequenceClosedPayload,
  SequenceEncodeCanceledPayload,
  SequenceEncodeCompletePayload,
  SequenceEncodeProgressPayload,
  SequenceUploadJobItemProgressPayload,
  SequenceUploadJobProgressPayload,
} from '../generated/types';

export const SubscriptionEvents = {
  FEEDBACK_BUTTON: 'feedbackButton',
  IMPORT_EVENTS: 'importEvents',
  ON_SIGN_IN_CHANGED: 'signInChanged',
  SEQUENCE_EVENTS: 'sequenceEvents',
  THEME_CHANGED: 'themechanged',
} as const;

export type PubSubEventMap = {
  [SubscriptionEvents.IMPORT_EVENTS]: {
    importEvents: ImportEventsPayload;
  };
  [SubscriptionEvents.THEME_CHANGED]: {
    themeChanged: string;
  };
  [SubscriptionEvents.SEQUENCE_EVENTS]: {
    sequenceEvents:
      | SequenceActivatedPayload
      | SequenceClosedPayload
      | SequenceEncodeCanceledPayload
      | SequenceEncodeCompletePayload
      | SequenceEncodeProgressPayload
      | SequenceUploadJobItemProgressPayload
      | SequenceUploadJobProgressPayload;
  };
  [SubscriptionEvents.FEEDBACK_BUTTON]: {
    feedbackButtonTriggered: string;
  };
  [SubscriptionEvents.ON_SIGN_IN_CHANGED]: {
    signInChanged: boolean;
  };
};
